
<dl class="row" *ngIf="loaded">
    <dt class="col-sm-3" *ngIf="gear['image_filename'] != ''">
        Billede
    </dt>
    <dd class="col-sm-9" *ngIf="gear['image_filename'] != ''">
        <img (click)="showFullImage(gear['image_filename'])" class="imgThumb" [src]="'assets/images/thumbnails/'+gear['image_filename']">
    </dd>
  <dt class="col-sm-3">
      Kategori
  </dt>
  <dd class="col-sm-9">
      {{categoriesObj[gear['category_id']]['name']}}
  </dd>
  <dt class="col-sm-3">Betegnelse</dt>
  <dd class="col-sm-9">{{gear['betegnelse']}}</dd>

  <dt class="col-sm-3">Placering</dt>
  <dd class="col-sm-9">
    <p>{{gear['placering']}}</p>
  </dd>

  <dt class="col-sm-3">Postnr</dt>
  <dd class="col-sm-9">{{gear['postnr']}}</dd>

  <dt class="col-sm-3">Minimums frist</dt>
  <dd class="col-sm-9">{{gear['minimums_frist']}} dag(e)</dd>

  <dt class="col-sm-3">Særligt</dt>
  <dd class="col-sm-9">
      <p>
          {{gear['saerligt']}}
      </p>
  </dd>
  <dt class="col-sm-3">Kontaktperson</dt>
  <dd class="col-sm-9"></dd>
  <dt class="col-sm-3 kpPad">Navn</dt>
  <dd class="col-sm-9">{{gear['kp_navn']}}</dd>

  <dt class="col-sm-3 kpPad">Email</dt>
  <dd class="col-sm-9">{{gear['kp_email']}}</dd>

  <dt class="col-sm-3 kpPad">Telefonnr</dt>
  <dd class="col-sm-9">{{gear['kp_tlf']}}</dd>
  
</dl>
<div *ngIf="loaded && (!isOwner || selfReservation)">
    <div class="row">

        <div class="col-md-12">
            <h2>Reserver udstyr:</h2>
        </div>
    </div>
    <div class="row">
        <div class="col-md-4">
            <ul>
                <li><span style="background: yellow">Reserveret</span></li>
                <li><span style="background: red">Udlånt/bruges</span></li>
            </ul>
            <div>
                Vælg et datointerval - klik på start og slut
            </div>
            <mat-form-field appearance="fill">
                
                <mat-label>Vælg et datointerval</mat-label>
                <mat-date-range-input [formGroup]="range" [rangePicker]="rangePicker" [dateFilter]="dateFilter" >
                <input matStartDate formControlName="start" placeholder="Start dato" [matDatepickerFilter]="myFilter">
                <input matEndDate formControlName="end" placeholder="Slut dato" [matDatepickerFilter]="myFilter" (dateChange)="onDateSelect()">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
                <mat-date-range-picker #rangePicker [dateClass]="dateClass">
                <mat-date-range-picker-actions>
                    <button mat-button matDateRangePickerCancel>Annullér</button>
                    <button mat-raised-button color="primary" matDateRangePickerApply>Vælg</button>
                </mat-date-range-picker-actions>
                </mat-date-range-picker>
            </mat-form-field>
    
    
    
    
    
            <!--<mat-form-field appearance="fill">
                <mat-label>Choose a date</mat-label>
                <input matInput [matDatepicker]="picker"  [matDatepickerFilter]="myFilter" [formControl]="what">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker [dateClass]="dateClass"></mat-datepicker>
            </mat-form-field> -->
        </div>
        <div class="col-md-8" *ngIf="rangeHasBeenSelected && !selfReservation">
            <div *ngIf="!reservationSuccess">
                <div class="form-group">
                    <textarea class="form-control" [formControl]="reservationComment" rows="4" placeholder="Kommentar til anmodning"></textarea>
                </div>
                <button class="btn btn-success" (click)="requestReservation()">Anmod om at låne</button>
            </div>
            <div *ngIf="reservationSuccess" class="alert alert-success">
                Din anmodning om at låne dette udstyr er blevet registreret!
            </div>
            <div *ngIf="reservationFail" class="alert alert-danger">
                {{reservationFailReason}}
            </div>
        </div>
        <div class="col-md-8" *ngIf="rangeHasBeenSelected && selfReservation">
            <div *ngIf="!reservationSuccess">
                <!--<div class="form-group">
                    <textarea class="form-control" [formControl]="reservationComment" rows="4" placeholder="Kommentar til anmodning"></textarea>
                </div>-->
                
                <button class="btn btn-success" (click)="requestReservation()">Reserver til dig selv</button>
            </div>
            <div *ngIf="reservationSuccess" class="alert alert-success">
                Dette udstyr er nu sat som optaget i den givne periode!
            </div>
            <div *ngIf="reservationFail" class="alert alert-danger">
                {{reservationFailReason}}
            </div>
        </div>
    </div>
    <div class="row" *ngIf="selfReservation">
        <div class="col-md-4">
            <button class="btn btn-info" (click)="selfReservation = false">Gå tilbage</button>
        </div>
    </div>

    
    
</div>
<div *ngIf="loaded && isOwner && !selfReservation">
    <div class="row">
        <h2>Reservationer:</h2>
    </div>
    <div class="row">

        <div class="col-md-12">
            <div *ngIf="handleRequestFail" class="alert alert-danger">
                {{handleRequestFailReason}}
            </div>
        </div>
    </div>
    <div class="row">

        <div class="col-md-4">
                <mat-calendar #calendar [dateClass]="dateClass" [selected]="selectedDate" (selectedChange)="selectedChange($event)">
                
                </mat-calendar>
        </div>
        <div class="col-md-8" >
            <div class="alert alert-warning" *ngIf="getReservationFail">{{getReservationFailReason}}</div>
            <dl class="row" *ngIf="hasReservation"> 
                <dt class="col-md-3">
                    Brugernavn:
                </dt>
                <dd class="col-md-9">
                    {{selectedReservationBorrower['username']}}
                </dd>
                <dt class="col-md-3">
                    Navn:
                </dt>
                <dd class="col-md-9">
                    {{selectedReservationBorrower['name']}}
                </dd>
                <dt class="col-md-3">
                    Start dato:
                </dt>
                <dd class="col-md-9">
                    {{selectedReservation['start_date']}}
                </dd>

                <dt class="col-md-3">
                    Slut dato:
                </dt>
                <dd class="col-md-9">
                    {{selectedReservation['end_date']}}
                </dd>


                <dt class="col-md-3">
                    Kommentar:
                </dt>
                <dd class="col-md-9">
                    <p>{{selectedReservation['comment']}}</p>
                </dd>
                <dt class="col-md-3">
                    Status:
                </dt>
                <dd class="col-md-9">
                    <div>

                        <span *ngIf="selectedReservation['status'] == 'reserveret'" class="alert alert-warning">Reserveret</span>
                        <span *ngIf="selectedReservation['status'] == 'udlaant'" class="alert alert-danger">Udlånt</span>
                        <span *ngIf="selectedReservation['status'] == 'bruges'" class="alert alert-danger">Bruges</span>
                    </div>
                    
                </dd>
                <dt class="col-md-3">

                </dt>
                <dd class="col-md-9">
                    <div>
                        <div class="btn-group">
                            <button class="btn btn-sm btn-primary" *ngIf="selectedReservation['status'] == 'reserveret'" (click)="acceptRequest(+selectedReservation['id'])">Accepter</button>
                            <button class="btn btn-sm btn-warning" *ngIf="selectedReservation['status'] == 'reserveret'" (click)="denyRequest(+selectedReservation['id'])">Afvis</button>
                            <button class="btn btn-sm btn-info" *ngIf="selectedReservation['status'] == 'udlaant' || selectedReservation['status'] == 'bruges'" (click)="unsetRequest(selectedReservation['id'])">Frigiv</button>
                        </div>
                    </div>
                </dd>
            </dl>
        </div>
    </div>
    <div class="row">
        <div class="col-md-4">
            <button class="btn btn-info" (click)="selfReservation = true">Reserver til eget brug</button>
        </div>
    </div>
    <!--<table class="table">
        <thead>
            <tr>
                <th>Start dato</th>
                <th>Slut dato</th>
                <th>Status</th>
                <th>Handlinger</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let r of reservations">
                <td>
                    {{r['start_date']}}
                </td>
                <td>
                    {{r['end_date']}}
                </td>
                <td>
                    <span *ngIf="r['status'] == 'reserveret'" style="color: yellow">Reserveret</span>
                    <span *ngIf="r['status'] == 'udlaant'" style="color: red">Udlånt</span>
                    <span *ngIf="r['status'] == 'bruges'" style="color: red">Bruges</span>
                </td>
                <td>
                    <div class="btn-group">
                        <button class="btn btn-sm btn-primary" *ngIf="r['status'] == 'reserveret'" (click)="acceptRequest(+r['id'])">Accepter</button>
                        <button class="btn btn-sm btn-warning" *ngIf="r['status'] == 'reserveret'" (click)="denyRequest(+r['id'])">Afvis</button>
                        <button class="btn btn-sm btn-info" *ngIf="r['status'] == 'udlaant' || r['status'] == 'bruges'" (click)="unsetRequest(+r['id'])">Frigiv</button>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>-->
</div>